import { publishSweepEventToBlob } from '../../api/agency-profile';
import { logDetails } from "../../api/logger-configuration";

// Generate a unique request ID
export const getRequestId = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
        .replace(/[xy]/g, function (c) {
            const r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
}


export const createPublishSweepEventRequest = (agencyId, eventName, uploadedBy) => ({
    "Id": getRequestId(),
    "AgencyId": agencyId,
    "UploadedBy": uploadedBy,
    "EventName": eventName,
});

// Publish sweep event with success and error handling
export const publishSweepEvent = (agencyId, eventName, uploadedBy, successMessage) => {
    const publishSweepEventRequest = createPublishSweepEventRequest(agencyId, eventName, uploadedBy);

    publishSweepEventToBlob(
        publishSweepEventRequest,
        () => {
            logDetails(successMessage);
        },
        () => {
        }
    );
};